import { create } from '@/shared/lib/zustand';
import type { SelectOption } from '@/shared/ui';
import { immer } from 'zustand/middleware/immer';

type FacilityFloorPlanFiltersState = {
  currentPage: number;
  search: string;
  statuses: SelectOption[] | null;
  floors: SelectOption[] | null;
  /** Portfolio Mode only — ignored when the table is scoped to one facility. */
  facilities: SelectOption[] | null;

  setFilters: (
    filters: Partial<Omit<FacilityFloorPlanFiltersState, 'setFilters'>>
  ) => void;
};

export const useFacilityFloorPlanFiltersStore =
  create<FacilityFloorPlanFiltersState>()(
    immer((set) => ({
      currentPage: 1,
      search: '',
      statuses: null,
      floors: null,
      facilities: null,

      setFilters: (filters) =>
        set((state) => {
          Object.assign(state, filters);
        }),
    }))
  );
